export const signatureOptions = ["MANUALLY", "ESIGN"];
import { IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import {
  ISignatureComponentConfigurationClient,
  ISignatureComponentConfigurationServer,
} from "./interface";
export const transformSignatureFieldConfigClientToServer = (
  fieldConfigClient: ISignatureComponentConfigurationClient
): ISignatureComponentConfigurationServer => {
  const {
    initialValue,
    placeHolder,
    isPII,
    isDuplicateAllowed,
    signatureType,
    canvasHeight,
    canvasColor,
    manualSignature,
    eSign,
  } = fieldConfigClient;

  const fieldConfigServer = {
    initialValue: initialValue,
    placeHolder: placeHolder,
    isPII: isPII,
    isDuplicateAllowed:isDuplicateAllowed,
    signatureType: signatureType,
    canvasHeight: canvasHeight,
    canvasColor: canvasColor,
    manualSignature: manualSignature,
    eSign: eSign,
  };
  return fieldConfigServer;
};

export const transformSignatureFieldConfigServerToClient = (
  fieldConfigServer: ISignatureComponentConfigurationServer
): ISignatureComponentConfigurationClient => {
  const {
    initialValue,
    placeHolder,
    isPII,
    isDuplicateAllowed,
    signatureType,
    canvasHeight,
    canvasColor,
    manualSignature,
    eSign,
  } = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    placeHolder: placeHolder,
    isPII: isPII,
    isDuplicateAllowed:isDuplicateAllowed,
    signatureType: signatureType,
    canvasHeight: canvasHeight,
    canvasColor: canvasColor,
    manualSignature: manualSignature,
    eSign: eSign,
  };
  return fieldConfigClient;
};

export const validateSignatureFieldSubmissionData = (
  fieldSubmissionData: IFormFieldSubmission,
): [boolean, string] => {
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const value = (fieldSubmissionValue && fieldSubmissionValue?.manualSignatureData) || "";
    if (!value) {
      return [false, "This is a Required Field"];
    }
  return [true, ""];
};